import * as actionTypes from '../actions/types';

const initialState = {
  accessToken: '',
  threadId: '',
  link: '',
  isLoading: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_QUIP_THREAD_ID:
      return {
        ...state,
        threadId: action.quipThreadId,
      };
    case actionTypes.ADD_QUIP_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.quipAccessToken,
      };
    case actionTypes.ADD_QUIP_LINK:
      return {
        ...state,
        link: action.quipLink,
      };
    case actionTypes.SET_QUIP_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.SET_QUIP_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};
